import {
  FETCH_UNITS_LIST_AGGR_REQUEST,
  FETCH_UNITS_LIST_AGGR_SUCCESS,
  FETCH_UNITS_LIST_AGGR_FAILURE,
  RESET_UNITS_LIST_AGGR,
  RELOAD_FILTERS,
  SET_USER_IMPERSONATION,
} from '../action/actionTypes';

const initialState = {
  sessionKey: null,
  loading: false,
  error: null,
  pages: {},
  pageMeta: {},
};

export default function unitsListAggr(state = initialState, action) {
  switch (action.type) {
    case FETCH_UNITS_LIST_AGGR_REQUEST: {
      const { sessionKey } = action.payload;
      if (sessionKey !== state.sessionKey) {
        return {
          ...initialState,
          sessionKey,
          loading: true,
        };
      }
      return {
        ...state,
        loading: true,
        error: null,
      };
    }
    case FETCH_UNITS_LIST_AGGR_SUCCESS:
      if (action.payload.sessionKey !== state.sessionKey) {
        return state;
      }
      return {
        ...state,
        loading: false,
        error: null,
        pages: action.payload.pages,
        pageMeta: action.payload.pageMeta,
      };
    case FETCH_UNITS_LIST_AGGR_FAILURE:
      if (action.payload?.sessionKey !== state.sessionKey) {
        return state;
      }
      return {
        ...state,
        loading: false,
        error: action.payload?.error,
      };
    case RESET_UNITS_LIST_AGGR:
    case RELOAD_FILTERS:
    case SET_USER_IMPERSONATION:
      return initialState;
    default:
      return state;
  }
}
